var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-loading"},[(_vm.loading)?_c('van-loading',{staticClass:"van-loading",attrs:{"size":"0.5rem"}}):_c('div',{staticClass:"loading-content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }